import {storeClockIcon, storeExamIcon, storeVaccineIcon} from "../../../../../assets";

export function blockIcon(blockName) {
    // Validation to prevent any runtime errors
    if (!blockName) {
        return "";
    }

    let icon;

    if (blockName.toLowerCase().includes("funcionamento")) {
        icon = storeClockIcon;
    } else if (blockName.toLowerCase().includes("coleta")) {
        icon = storeExamIcon;
    } else if (blockName.toLowerCase().includes("vacina")) {
        icon = storeVaccineIcon;
    } else {
        icon = storeClockIcon;
    }

    return icon;
}
